import type { AccountLocales } from '@/types/lang/locales'

export const accountEn: AccountLocales = {
    informationsTitle: 'Information',
    rolesTitle: 'Roles',
    changePasswordTitle: 'Change password',
    twoFATitle: '2 FA authentication',

    model: {
        name: 'Name',
        email: 'Email',
        roles: 'Roles',
        password: 'Password',
        confirmPassword: 'Confirm password',
        currentPassword: 'Current password'
    },

    twoFa: {
        twoFaActivated:
            'Two-factor authentication enabled. Please confirm with your authenticator app.',
        selectMode:
            'Vous pouvez créer un authenticator soit en scannant le QR Code sur votre application, soit en entrant le code secret.',
        secretCode: 'Code secret',
        enable2FaAction: 'Enable 2FA',
        disable2FaAction: 'Disable 2FA',
        twoFaEnterCode:
            'Enter the code shown on your authenticator app to confirm the 2FA activation.',
        authCode: 'Authenticator code',
        twoFAEnabledtitle: '2FA enabled'
    }
}
